/**
 * assets/bundle-set.js
 *
 * Drives the "bundle-set" snippet: two independent Dawn-style variant
 * pickers (top / bottom) sourced from a Product List metafield, plus a
 * single Add to Cart button that adds BOTH selected variants together via
 * the Shopify AJAX Cart API. The current/native product is never added.
 *
 * Reuses Dawn's own cart-drawer / cart-notification web components to
 * render the updated cart (renderContents), so drawer animations, cart
 * notifications, and upsell/recommendation sections all keep working
 * exactly as they do for a normal Dawn product form.
 */

document.addEventListener("click", (e) => {
  /* -------------------- Open -------------------- */

  const trigger = e.target.closest("[js-size_guide_popup_bundle]");

  if (trigger) {
    e.preventDefault();

    const type = trigger.dataset.type;

    const popup = document.getElementById(
      `${type}-size_guide_popup_open`
    );

    if (popup) {
      popup.classList.add("active");
      popup.style.display = "block";
    }

    return;
  }

  /* -------------------- Close Button -------------------- */

  if (e.target.closest(".closeBtn-pro")) {
    const popup = e.target.closest(".popup-pro");

    if (popup) {
      popup.classList.remove("active");
      popup.style.display = "none";
    }

    return;
  }

  /* -------------------- Outside Click -------------------- */

  document.querySelectorAll(".popup-pro.active").forEach((popup) => {
    if (!popup.contains(e.target)) {
      popup.classList.remove("active");
      popup.style.display = "none";
    }
  });

  /* -------------------- Tabs -------------------- */

  const tab = e.target.closest(
    ".popup_size_guide_tab_title_1_new, .popup_size_guide_tab_title_2_new"
  );

  if (!tab) return;

  e.preventDefault();

  const popup = tab.closest(".popup-pro");

  if (!popup) return;

  popup.querySelectorAll("ul li a").forEach((el) => {
    el.classList.remove("active");
  });

  popup
    .querySelectorAll(".popup_size_guide_tab_details_in_new")
    .forEach((el) => {
      el.style.display = "none";
    });

  tab.classList.add("active");

  if (tab.classList.contains("popup_size_guide_tab_title_1_new")) {
    popup.querySelector(".popup_size_guide_tab_1_new").style.display =
      "block";
  } else {
    popup.querySelector(".popup_size_guide_tab_2_new").style.display =
      "block";
  }
});

(function () {
  if (window.BundleSet) return; // avoid double-registration on re-render

  const STRINGS = Object.assign(
    {
      selectVariants: 'Please select variants',
      addToCart: 'Add to Cart',
      soldOut: 'Sold out',
      sale: 'Sale',
      genericError: 'Unable to add items to your cart. Please try again.',
    },
    window.bundleSetStrings || {}
  );

  class BundleSet {
    constructor(root) {
      this.root = root;
      this.state = { top: null, bottom: null };

      this.variantData = {
        top: this.parseVariantJSON('top'),
        bottom: this.parseVariantJSON('bottom'),
      };

      this.button = root.querySelector('[data-bundle-add-to-cart]');
      this.buttonText = root.querySelector('[data-bundle-button-text]');
      this.errorEl = root.querySelector('[data-bundle-error]');
      this.topTitleEl = root.querySelector('[data-bundle-top-title]');
      this.bottomTitleEl = root.querySelector('[data-bundle-bottom-title]');

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.bindEvents();
        if (this.variantData.top.length) {
        this.initSelection("top");
        }

        if (this.variantData.bottom.length) {
        this.initSelection("bottom");
        }
    }

    /* ---------------------------------------------------------------- */
    /* Setup                                                             */
    /* ---------------------------------------------------------------- */

    parseVariantJSON(type) {
      const el = this.root.querySelector(`[data-bundle-variant-json="${type}"]`);
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        console.error(`Bundle Set: could not parse variant JSON for "${type}"`, error);
        return [];
      }
    }
    

    bindEvents() {
      this.root.addEventListener('change', this.onChange);
      if (this.button) {
        this.button.addEventListener('click', this.onSubmit);
      }
    }

    initSelection(type) {
    let checked = this.root.querySelector(`input[name="${type}Size"]:checked`);

    // If nothing is selected, use the first available variant
    if (!checked) {
        checked = this.root.querySelector(
        `input[name="${type}Size"]:not(:disabled)`
        );

        if (checked) {
        checked.checked = true;
        }
    }

    if (checked) {
        this.applySelection(type, checked);
    }

    this.updateValidation();
    }

    onChange(event) {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT') return;
      if (target.name === 'topSize') this.applySelection('top', target);
      if (target.name === 'bottomSize') this.applySelection('bottom', target);
    }

    /* ---------------------------------------------------------------- */
    /* Selection / price / validation                                   */
    /* ---------------------------------------------------------------- */

    getVariant(type, id) {
      return this.variantData[type].find((variant) => `${variant.id}` === `${id}`);
    }

    applySelection(type, input) {
      const variant = this.getVariant(type, input.dataset.bundleId);
      if (!variant) return;

      this.state[type] = variant.available ? variant : null;

      this.updateTitle(type, input);
      this.updatePrice(type, variant);
      this.updateValidation();
      this.hideError();
    }

    updateTitle(type, input) {
      const el = type === 'top' ? this.topTitleEl : this.bottomTitleEl;
      if (!el) return;
      const label = this.root.querySelector(`label[for="${input.id}"]`);
      el.textContent = label ? label.getAttribute("data-meta-label") : input.getAttribute("data-meta-size");
    }

    updatePrice(type, variant) {
      const wrapper = this.root.querySelector(`[data-bundle-price="${type}"]`);
      if (!wrapper || !variant) return;

      const priceEl = wrapper.querySelector('[data-bundle-price-regular]');
      const compareEl = wrapper.querySelector('[data-bundle-price-compare]');
      const badgeEl = wrapper.querySelector('[data-bundle-badge]');

      if (priceEl) priceEl.textContent = variant.price_formatted;

      const onSale =
        variant.compare_at_price && variant.compare_at_price > variant.price;

      if (compareEl) {
        if (onSale) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (badgeEl) {
        if (!variant.available) {
          badgeEl.textContent = STRINGS.soldOut;
          badgeEl.hidden = false;
        } else if (onSale) {
          badgeEl.textContent = STRINGS.sale;
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
          badgeEl.textContent = '';
        }
      }
    }

    updateValidation() {
      if (!this.button) return;

      const hasTopProduct = this.variantData.top.length > 0;
      const hasBottomProduct = this.variantData.bottom.length > 0;
      const ready = (!hasTopProduct || this.state.top) && (!hasBottomProduct || this.state.bottom);

      this.button.disabled = false;
      if (ready) {
        this.button.removeAttribute('aria-disabled');
      } else {
        this.button.setAttribute('aria-disabled', 'true');
      }

      if (this.buttonText) {
        this.buttonText.textContent = STRINGS.addToCart;
      }
    }

    /* ---------------------------------------------------------------- */
    /* Add to cart                                                       */
    /* ---------------------------------------------------------------- */

    async onSubmit(event) {
      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      const hasTopProduct = this.variantData.top.length > 0;
      const hasBottomProduct = this.variantData.bottom.length > 0;

      if (hasTopProduct && !this.state.top) return;
      if (hasBottomProduct && !this.state.bottom) return;

      this.button.setAttribute('aria-disabled', 'true');
      this.setLoading(true);
      this.hideError();

        const items = [];

        if (this.state.top) {
        items.push({
            id: this.state.top.id,
            quantity: 1,
        });
        }

        if (this.state.bottom) {
        items.push({
            id: this.state.bottom.id,
            quantity: 1,
        });
        }

        if (!items.length) {
        this.showError("Please select a variant.");
        return;
        }

      try {
        await this.addToCart(items);
      } catch (error) {
        this.showError(error.message || STRINGS.genericError);
      } finally {
        this.setLoading(false);
        this.updateValidation();
      }
    }

    /**
     * Mirrors ProductForm.onSubmitHandler() in product-form.js as closely as
     * possible, so the bundle's Add to Cart behaves identically to Dawn's
     * native one. The key fix vs. the previous implementation: this makes a
     * SINGLE request to /cart/add.js and asks Shopify to render `sections`
     * and `sections_url` as part of that same response (exactly like
     * product-form.js's FormData does), instead of a follow-up GET against
     * the current page. That's what makes `response.sections` land in the
     * exact shape CartDrawer.renderContents() expects — no mismatched
     * markup, no missing #CartDrawer content, no stale trapFocus target.
     */
    async addToCart(items) {
      const cart =
        document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      // Same helper Dawn's product-form.js uses. Unlike product-form.js we
      // do NOT delete the Content-Type header, because we're sending a JSON
      // body (multi-item adds require the `items` array, which the
      // form-encoded / FormData endpoint doesn't support) rather than
      // FormData.
      const config = fetchConfig('javascript');
      config.body = JSON.stringify({
        items,
        // Ask Shopify to render the exact same sections Dawn's cart
        // components already know how to consume.
        sections: cart ? cart.getSectionsToRender().map((section) => section.id) : undefined,
        sections_url: window.location.pathname,
      });

      if (cart) cart.setActiveElement(document.activeElement);

      const response = await fetch(routes.cart_add_url, config);
      const result = await response.json();

      if (result.status) {
        // Same error shape Dawn's product-form.js reacts to, so any app
        // listening for cartError keeps working.
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'bundle-set',
          productVariantId: items[0]?.id,
          errors: result.errors || result.description,
          message: result.message,
        });
        throw new Error(result.description || result.message);
      }

      if (!cart) {
        // Same fallback product-form.js uses when there's no drawer/notification.
        window.location = routes.cart_url;
        return;
      }

      // Reuse Dawn's own pub/sub so upsells, recommendations, and any app
      // hooked into cartUpdate fire exactly as they would for a native add.
      const startMarker = CartPerformance.createStartingMarker('bundle:wait-for-subscribers');
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bundle-set',
        cartData: result,
      }).then(() => {
        CartPerformance.measureFromMarker('bundle:wait-for-subscribers', startMarker);
      });

      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

      // Feed the response straight into Dawn's own renderContents(),
      // untouched — same call product-form.js makes.
      CartPerformance.measure('bundle:paint-updated-sections', () => {
        cart.renderContents(result);
      });
    }

    /* ---------------------------------------------------------------- */
    /* UI helpers                                                        */
    /* ---------------------------------------------------------------- */

    setLoading(isLoading) {
      if (!this.button) return;
      this.button.classList.toggle('loading', isLoading);
      this.button.disabled = isLoading ? true : this.button.disabled;
      this.button.setAttribute('aria-busy', String(isLoading));
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    hideError() {
      if (!this.errorEl) return;
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-set]').forEach((root) => {
      if (root.bundleSetInstance) return; // already initialized
      root.bundleSetInstance = new BundleSet(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());

  // Re-init when Quick Add (or any AJAX-loaded modal) injects new markup.
  // Dawn's quick-add-bundle / product-modal components dispatch this on
  // most versions; harmless no-op if it never fires.
  document.addEventListener('quick-add:load', (event) => init(event.target));

  window.BundleSet = BundleSet;
  window.initBundleSet = init;
})();
